// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncrementBtn-incrementDecrementButton-QUa6z {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 2px;
	overflow: hidden;
	height: 58px;
	display: grid;
	grid-template-columns: 3fr 0fr 0fr;
}

.IncrementBtn-incrementDecrementText-zku7H {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 18px 20px;
	margin: 0px;
	font-size: 16px;
	line-height: 1;
	vertical-align: middle;
	font-weight: normal;
	background: var(--primary-input-bg);
}

.IncrementBtn-iconButton-kONEi {
	border-color: var(--primary-border);
	border-width: 0px 0px 0px 1px;
	border-radius: 0px;
	padding: 12px 21px;
	height: 58px;
	margin: 0px 0px;
	font-size: 15px;
	line-height: 1px;
	color: var(--secondary-bg) !important;
	background-color: var(--primary-input-bg) !important;
}

.IncrementBtn-iconButton-kONEi:hover,
.IncrementBtn-iconButton-kONEi:focus,
.IncrementBtn-iconButton-kONEi:active {
	background-color: var(--primary-input-bg) !important;
	border-color: var(--primary-border);
	border-width: 0px 0px 0px 1px;
	margin-left: 0px;
	outline: 0 !important;
	-webkit-box-shadow: none;
	        box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./src/components/ListPlaceStep1/IncrementBtn/IncrementBtn.css"],"names":[],"mappings":"AAAA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;CACZ,aAAa;CACb,kCAAkC;AACnC;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,mCAAmC;AACpC;;AAEA;CACC,mCAAmC;CACnC,6BAA6B;CAC7B,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,qCAAqC;CACrC,oDAAoD;AACrD;;AAEA;;;CAGC,oDAAoD;CACpD,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB,qBAAqB;CACrB,wBAAgB;SAAhB,gBAAgB;AACjB","sourcesContent":[".incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 2px;\n\toverflow: hidden;\n\theight: 58px;\n\tdisplay: grid;\n\tgrid-template-columns: 3fr 0fr 0fr;\n}\n\n.incrementDecrementText {\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tpadding: 18px 20px;\n\tmargin: 0px;\n\tfont-size: 16px;\n\tline-height: 1;\n\tvertical-align: middle;\n\tfont-weight: normal;\n\tbackground: var(--primary-input-bg);\n}\n\n.iconButton {\n\tborder-color: var(--primary-border);\n\tborder-width: 0px 0px 0px 1px;\n\tborder-radius: 0px;\n\tpadding: 12px 21px;\n\theight: 58px;\n\tmargin: 0px 0px;\n\tfont-size: 15px;\n\tline-height: 1px;\n\tcolor: var(--secondary-bg) !important;\n\tbackground-color: var(--primary-input-bg) !important;\n}\n\n.iconButton:hover,\n.iconButton:focus,\n.iconButton:active {\n\tbackground-color: var(--primary-input-bg) !important;\n\tborder-color: var(--primary-border);\n\tborder-width: 0px 0px 0px 1px;\n\tmargin-left: 0px;\n\toutline: 0 !important;\n\tbox-shadow: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"incrementDecrementButton": `IncrementBtn-incrementDecrementButton-QUa6z`,
	"incrementDecrementText": `IncrementBtn-incrementDecrementText-zku7H`,
	"iconButton": `IncrementBtn-iconButton-kONEi`
};
module.exports = ___CSS_LOADER_EXPORT___;
